import React from 'react';
import { FileDownload } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import { ILZTimelineData } from '../../../types/timeline/timelineInterface';
import { ILZTimelineDeviceData } from '../../../types/deviceConnection';

const DataDownloader = ({
  data,
  selectedId
}: {
  data: ILZTimelineData | ILZTimelineDeviceData;
  selectedId: number;
}) => {
  const convertToCSV = (obj: any) => {
    const rows = [];
    rows.push(
      'Date,LightZoneName,LightingStatus,Color,Brightness,PatternSpeed,ChangeReason,StartDate,EndDate,ChangedData'
    );
    Object.entries(obj).forEach(([date, events]: [string, unknown]) => {
      if (Array.isArray(events)) {
        events.forEach((event: any) => {
          const row = [
            date,
            event.lightZoneName,
            event.lightingStatus,
            event.color,
            event.brightness,
            event.patternSpeed,
            event.changeReason,
            moment(event.startDate).format('YYYY-MM-DD hh:mm a'),
            moment(event.endDate).format('YYYY-MM-DD hh:mm a'),
            JSON.stringify(event.changedData)
          ];
          rows.push(row.join(','));
        });
      }
    });

    return rows.join('\n');
  };

  const downloadCSV = () => {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Timeline Report lightZoneID_${selectedId}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = () => {
    const flatData: any[] = [];
    Object.entries(data).forEach(([date, events]) => {
      if (Array.isArray(events)) {
        events.forEach((event: any) => {
          flatData.push({
            Date: date,
            LightZoneName: event.lightZoneName,
            LightingStatus: event.lightingStatus,
            Color: event.color,
            Brightness: event.brightness,
            PatternSpeed: event.patternSpeed,
            ChangeReason: event.changeReason,
            StartDate: event.startDate,
            EndDate: event.endDate,
            ChangedData: JSON.stringify(event.changedData)
          });
        });
      }
    });
  };

  return (
    <Tooltip title="Download CSV" className="p-button-raised">
      <FileDownload onClick={() => downloadCSV()} />
    </Tooltip>
  );
};

export default DataDownloader;
